import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Reliable full-viewport height for iOS Safari & mobile browsers.
// window.innerHeight = actual visible height, not the broken 100vh/dvh.
function setRealVh() {
  document.documentElement.style.setProperty('--real-vh', window.innerHeight * 0.01 + 'px');
}
setRealVh();
window.addEventListener('resize', setRealVh);
window.addEventListener('orientationchange', setRealVh);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
